import type { Theme } from '@mui/material';

export const styles = {
  row: (highlight: boolean) => (theme: Theme) => ({
    backgroundColor: highlight ? theme.colors.secondary[400] : 'transparent',
    py: 1.5,
    px: 1,
  }),
};
